import { caracteristiqueBailleur } from "./InterfaceTerritoire";
import ficheClass from "./classFiche";

//import data from './prototypeDataTerritoire';
import * as _ from "lodash";

const column = ["DE", "AT", "PA", "ON"];

export default class bailleurClass extends ficheClass {
    caracteristiqueBailleur = new caracteristiqueBailleur();

    constructor(data: any, dataTerritoire: any) {
        super(data);

        this.caracteristiqueBailleur.nombre.OLS =
            data.caracteristiqueHlm?.nombre?.PA?.nb;
        this.caracteristiqueBailleur.nombre.PA =
            dataTerritoire.caracteristiqueHlm?.nombre?.PA?.nb;
        this.caracteristiqueBailleur.nombre.PDM =
            this.caracteristiqueBailleur?.nombre?.OLS /
            this.caracteristiqueBailleur?.nombre?.PA;
        this.caracteristiqueBailleur.nombre.PDMGraph = Math.min(
            this.caracteristiqueBailleur?.nombre?.PDM,
            0.5
        );

        this.caracteristiqueBailleur.offreNouvelleMoyenneAn.OLS =
            data.caracteristiqueHlm?.nombre?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelleMoyenneAn.PA =
            dataTerritoire.caracteristiqueHlm?.nombre?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelleMoyenneAn.PDM =
            this.caracteristiqueBailleur?.offreNouvelleMoyenneAn?.OLS /
            this.caracteristiqueBailleur?.offreNouvelleMoyenneAn?.PA;
        this.caracteristiqueBailleur.offreNouvelleMoyenneAn.PDMGraph = Math.min(
            this.caracteristiqueBailleur?.offreNouvelleMoyenneAn?.PDM,
            0.5
        );

        this.caracteristiqueBailleur.offreNouvelle2015.OLS =
            data.caracteristiqueHlm?.lgtNeuf2015?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelle2015.PA =
            dataTerritoire.caracteristiqueHlm?.lgtNeuf2015?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelle2014.OLS =
            data.caracteristiqueHlm?.lgtNeuf2014?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelle2014.PA =
            dataTerritoire.caracteristiqueHlm?.lgtNeuf2014?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelle2013.OLS =
            data.caracteristiqueHlm?.lgtNeuf2013?.ON?.nb;
        this.caracteristiqueBailleur.offreNouvelle2013.PA =
            dataTerritoire.caracteristiqueHlm?.lgtNeuf2013?.ON?.nb;

        this.caracteristiqueBailleur.tauxCroissance.OLS =
            this.caracteristiqueBailleur.offreNouvelleMoyenneAn.OLS /
            this.caracteristiqueBailleur.nombre.OLS;
        this.caracteristiqueBailleur.tauxCroissance.PA =
            this.caracteristiqueBailleur.offreNouvelleMoyenneAn.PA /
            this.caracteristiqueBailleur.nombre.PA;

        this.caracteristiqueBailleur.mutationAttribution.PA = "-";
        this.caracteristiqueBailleur.mutationAttribution.NB = "-";
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/classBailleur.ts